import React from 'react';
import { connect } from 'react-redux';
import { listUsers } from '~/actions/user';
import { IconButton } from 'react-toolbox/lib/button';
import Tag from '~/components/Tag';
import styleDialog from '~/style/dialog.scss';

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  componentDidMount() {
    listUsers(this.props.dispatch, this.context.apiClient);
  }

  render() {
    return (
      <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div className={styleDialog.content}>
            <div>Pick a user</div>
            {Object.keys(this.props.users).map(id => <Tag
              type="user"
              id={id}
              key={id}
              style={{ margin: '5px 5px 0 0' }}
              onClick={() => {
                this.props.data.onChange(id);
                this.context.dialogClose(this.props.dialogId);
              }}
            />)}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  users: state.getIn(['user', 'users']).toJS(),
});

export default connect(mapStateToProps)(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/UserPick/index.js